<script lang="ts">
export default {
  name: 'KkTextarea',
}
</script>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export interface Props {
  modelValue: string
  id?: string
  disabled?: boolean
  width?: string
  placeholder?: string
  rows?: number
}

export interface Emits {
  (key: 'update:modelValue', value: Props['modelValue']): void
}

const props = withDefaults(defineProps<Props>(), {
  width: '100%',
  rows: 5,
})
const emits = defineEmits<Emits>()
const { t } = useI18n()

const valueModel = computed({
  get: () => props.modelValue,
  set: (value) => emits('update:modelValue', value),
})

const placeholder = computed(() => props.placeholder || t('labels.placeholder.basic'))

const styles = computed(() => ({
  width: props.width,
}))
</script>

<template>
  <textarea
    :id="id"
    ref="textarea"
    v-model="valueModel"
    :disabled="disabled"
    :placeholder="placeholder"
    :style="styles"
    :rows="rows"
    class="textarea"
  />
</template>

<style lang="scss" scoped>
@import "../../../../../stylesheets/biz_spa/foundation/_var.scss";
.textarea {
  display: block;
  width: 100%;
  padding: 12px 16px;
  border: 1px solid $color-base-c;
  border-radius: 4px;
  background-color: $color-base-a;
  font-size: 14px;
  line-height: 1.5;
  &::placeholder {
    color: rgba($color-font-base, .55);
  }
  &:disabled {
    background-color: #E2E2E2;
    resize: none;
  }
}
</style>
